import { render } from "./ExchangeError.vue?vue&type=template&id=3876d978&scoped=true"
import script from "./ExchangeError.vue?vue&type=script&lang=js"
export * from "./ExchangeError.vue?vue&type=script&lang=js"

import "./ExchangeError.vue?vue&type=style&index=0&id=3876d978&lang=scss&scoped=true"

import exportComponent from "/var/www/html/app_player/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3876d978"]])

export default __exports__